import * as MD from '@material-ui/core';
import styled from 'styled-components';
import { grey } from '@material-ui/core/colors';
import { Theme, withStyles, createStyles } from '@material-ui/core/styles';

import MuiButton from '@material-ui/core/Button';
import { TextField } from '@material-ui/core';
import MuiRadio from '@material-ui/core/Radio';
import MuiCheckbox from '@material-ui/core/Checkbox';
import MuiFormControlLabel from '@material-ui/core/FormControlLabel';
import MuiTableCell from '@material-ui/core/TableCell';
import { makeStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import "./ToggleSwitchV2.scss";

import MuiDialogTitle from '@material-ui/core/DialogTitle';
import CloseIcon from '@material-ui/icons/Close';
//Router
import {
  Link
} from "react-router-dom";
import React from 'react';

const styles = (theme: any) => MD.createStyles({
  closeButton: {
    position: 'absolute',
    right: '0px',
    top: '4px',
    color: theme.palette.grey[500],
  },
})
export const ButtonDensed = MD.withStyles({
  root: {
    padding: '1px 8px',
    fontSize: '12px',
    color: '#fff',
    textTransform: 'none'
  }
})(MuiButton);

export const ButtonDensedNoColor = MD.withStyles({
  root: {
    padding: '1px 8px',
    fontSize: '12px',
  }
})(MuiButton);

export const DensedTextField = styled(TextField)`
.MuiInputBase-input {
  padding: 4px;
  font-size: 13px;
}
.MuiInputLabel-formControl {
  top: -7px;
  font-size: 13px;
  font-weight: 300;
}
.MuiFormLabel-root.Mui-focused {
  top: 0;
}
.MuiInputLabel-shrink {
  top: 0 !important;
}
`;

export const DensedTextFieldDark = styled(TextField)`
.MuiInputBase-input {
  padding: 4px;
  font-size: 13px;
}
.MuiInputLabel-formControl {
  top: -7px;
  font-size: 13px;
  font-weight: 100;
}
.MuiFormLabel-root.Mui-focused {
  top: 0;
}
.MuiInputLabel-shrink {
  top: 0 !important;
}
input {
  color: #000
}
`;


export const DarkRadio = withStyles({
  root: {
    color: grey[400],
    '&$checked': {
      color: grey[600],
    },

  },

  checked: {},
})(MuiRadio);

export const DarkCheckbox = withStyles({
  root: {
    color: grey[300],
  },

  checked: {},
})(MuiCheckbox);

export const FormControlLabelMedium = withStyles({
  label: {
    fontSize: '14px'
  }
})(MuiFormControlLabel);

export const FormControlLabelSmall = withStyles({
  label: {
    fontSize: '13px'
  }
})(MuiFormControlLabel);

export const FormControlLabelTopLeftPlacement = withStyles({
  label: {
    fontSize: '14px',
    display: 'flex',
    alignSelf: 'flex-start'
  }
})(MuiFormControlLabel);

export const StyledLink = styled(Link)`
    text-decoration: none;
    color: #fff;

    &:focus, &:hover, &:visited, &:link, &:active {
        text-decoration: none;
    }
`;

export const TableHeaderCell = withStyles(theme => ({
  root: {
    padding: '0px 5px',
    fontSize: '12px',
    textTransform: 'uppercase',
    fontWeight: 500,
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary
  }
}))(MuiTableCell);

export const TableCell = withStyles(theme => ({
  root: {
    padding: '2px',
    fontSize: '11px',
    fontWeight: 500,
    color: theme.palette.text.primary,
    // borderBottom: '1px solid #EEEEEE'
  }
}))(MuiTableCell);

const useStylesBootstrap = makeStyles((theme) => ({
  arrow: {
    color: theme.palette.background.paper,
  },
  tooltip: {
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    fontSize: '13px'
  },
}));

export function BootstrapTooltip(props: any) {
  const classes = useStylesBootstrap();

  return <Tooltip arrow classes={classes} {...props} />;
}
export const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 15,
    borderRadius: 5,
  },
  colorPrimary: {
    backgroundColor: "#EEEEEE",
  },
  bar: {
    borderRadius: 5,
    backgroundColor: '#1a90ff',
  },
}))(MD.LinearProgress);

export const StyledBadge = withStyles((theme: Theme) =>
  createStyles({
    badge: {
      padding: '0px',
      width: '1%'
    },
  }),
)(MD.Badge);

type DialogProps =
  MD.WithStyles<typeof styles>

export interface DialogTitleProps extends DialogProps {
  id: string;
  children: React.ReactNode;
  onClose: () => void;
  theme: any;
}

export const DialogTitle = MD.withTheme(MD.withStyles(styles)((props: DialogTitleProps) => {
  const { children, classes, theme, onClose, ...other } = props as any;
  return (
    <MuiDialogTitle disableTypography {...other}
      style={{
        cursor: 'move',
        color: theme.palette.primary.main,
        padding: theme.spacing(2),
        textAlign: 'center'
      }}>
      <MD.Typography style={{ textTransform: 'uppercase' }}>{children}</MD.Typography>
      {onClose ? (
        <MD.IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </MD.IconButton>
      ) : null}
    </MuiDialogTitle>
  );
}));

interface IToggleSwitchProps {
  id: any;
  checked: boolean;
  onChange: (bool: boolean) => void;
  optionLabels: any[];
  theme: any;
  name?: any;
}
interface IToggleProps {
  id: any;
  checked: boolean;
  onChange: (bool: boolean) => void;
  leftLabel: string;
  rightLabel: string
  theme: any;
}
export const ToggleSwitch = MD.withTheme(MD.withStyles(styles)((props: IToggleSwitchProps) => {
  function handleKeyPress(e: any) {
    if (e.keyCode !== 32) return;

    e.preventDefault();
    props.onChange(!props.checked);
  }
  return (
    <div className={"toggle-switch"}>
      <input
        type="checkbox"
        name={props.name}
        className="toggle-switch-checkbox"
        id={props.id}
        checked={props.checked}
        onChange={(e) => props.onChange(e.target.checked)}
      />
      <label
        className="toggle-switch-label"
        onKeyDown={(e) => handleKeyPress(e)}
        htmlFor={props.id}
      >
        <span
          className={"toggle-switch-inner"}
          data-yes={props.optionLabels[0]}
          data-no={props.optionLabels[1]}
          tabIndex={-1}
        />
        <span className={"toggle-switch-switch"} tabIndex={-1} />
      </label>
    </div>
  );
}));
export const ToggleSwitchV2 = MD.withTheme(MD.withStyles(styles)((props: IToggleProps) => {
  return (
    <div>
      <input
        className="switch-field-input"
        type="radio"
        id="switch_left"
        name="switchToggle"
        value={props.leftLabel}
        onChange={(e) => props.onChange(e.target.checked)}
        checked={!props.checked}
      />
      <label
        className="switch-field-label" htmlFor="switch_left">{props.leftLabel}</label>

      <input
        className="switch-field-input"
        type="radio"
        id="switch_right"
        name="switchToggle"
        value={props.rightLabel}
        onChange={(e) => props.onChange(e.target.checked)}
        checked={props.checked}
      />
      <label
        className="switch-field-label" htmlFor="switch_right">{props.rightLabel}</label>
    </div>);
}));
